import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AdminLayout, LoginLayout, MainLayout } from './layout/layout'
import Home from './pages/home'
import SignIn from './pages/Signin'
import Upload from './pages/Upload'
import { UserPage } from './pages/User'
import { PartPage } from './pages/Part'
import { GroupPage } from './pages/Group'
import { DevicePage } from './pages/Devcie'
import { CalcPage } from './pages/Calc'
import { NotFoundPage } from './pages/NotFound'
import { HistoryPage } from './pages/History'
import { HistoryComparePage } from './pages/History/compare'
import Activity from './pages/Activity'
import { DocsGuidePage } from './pages/docs/guide'

interface RouterProps {
  user: User | null
}
export interface User {
  RT?: string
}

const Router = ({ user }: RouterProps) => {
  return (
    <Routes>
      {/* MainLayout을 사용하는 공통 라우트 */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/history" />} />  {/* 기본 경로 리다이렉트 */}
      </Route>
      <Route path="/user" element={<MainLayout />}>
        <Route index element={<UserPage />} />
      </Route>
      <Route path="/part" element={<MainLayout />}>
        <Route index element={<PartPage />} />
      </Route>
      <Route path="/group" element={<MainLayout />}>
        <Route index element={<GroupPage />} />
      </Route>
      <Route path="/device" element={<MainLayout />}>
        <Route index element={<DevicePage />} />
      </Route>
      <Route path="/upload" element={<MainLayout />}>
        <Route index element={<Upload />} />
      </Route>
      <Route path="/activity" element={<MainLayout />}>
        <Route index element={<Activity />} />
      </Route>
      <Route path="/history" element={<MainLayout />}>
          <Route index element={<HistoryPage />} />
          <Route path="compare" element={<HistoryComparePage />} />
      </Route>
      <Route path="/calc" element={<MainLayout />}>
        <Route index element={<CalcPage />} />
      </Route>

      <Route path="/unauth" element={<LoginLayout />}>
        <Route path="signin" element={<SignIn />} />
      </Route>

      <Route path="/docs">
        <Route path="guide" element={<DocsGuidePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default Router
